import { Currency } from 'dinero.js';
import { FunctionalComponent } from 'vue';
import { merchantInterface } from '@/api/merchants';
import { serviceProviderInterface, ServiceProviderPermissionEnum } from '@/api/serviceProviders';
import { AnalyticsKeys } from '@/composables/useAnalytics';
import { tableItemInterface } from '@/helpers/tables/types';

export enum AppEntitlementEnum {
    BaseAccess = 'base_access',
    Locations = 'locations',
    AmazonShipments = 'amazon_shipments',
    Orders = 'orders',
}

export type AppPermissionEnum = ServiceProviderPermissionEnum | 'viewCompanyServicesPrice' | 'editCompanyService';

export interface Spark {
    env: 'local' | 'production' | 'demo' | 'testing' | 'staging'
    stripeKey: string
    appName: string
    appBaseDomain: string
    serviceProvider?: serviceProviderInterface
    merchant?: merchantInterface
    impersonatingUserId: number | null
    sentryPublicDsn?: string
    releaseTag?: string
    analyticsKeys: AnalyticsKeys
    chargebeeSite: string
    featurebaseUserIdHash: string | null
    featurebaseServiceProviderIdHash: string | null
    featurebaseOrganization: string | null
}

export interface dropdownItemInterface {
    text: string
    href?: string
    icon?: FunctionalComponent
    clickFunc?: () => void
}

export interface shipmentNameFormInterface {
    name: string
}

export interface SelectOption<
    TValue = string | number | boolean,
> {
    value: TValue
    name: string
    disabled?: boolean
}

export interface defaultIntertiaPropsInterface {
    errors: { [key: string]: string }
    flash: {
        successMessages: string[]
        errorMessages: string[]
    }
}

export interface moneyInterface {
    amount: number
    currency: Currency
}

export interface requestFilterInterface {
    name: string
    value: string
}

export interface DataFetcherSort {
    field: string
    direction: 'asc' | 'desc'
    order: number
}

interface DataFetcherResponseMeta {
    total: number
    perPage: number
    currentPage: number
    lastPage: number
    from: number | null
    to: number | null
}

interface DataFetcherResponseWithMetaInAKey<TData> {
    data: TData[]
    meta: DataFetcherResponseMeta
}

interface DataFetcherResponseWithMetaInRoot<TData> extends DataFetcherResponseMeta {
    data: TData[]
}

export type DataFetcherResponse<TData> = DataFetcherResponseWithMetaInAKey<TData> | DataFetcherResponseWithMetaInRoot<TData>;

export function isResponseWithMetaInRoot<T>(response: DataFetcherResponse<T>): response is DataFetcherResponseWithMetaInRoot<T> {
    return !('meta' in response);
};

export interface DataFetcherFunction<TData> {
    (page: number, pageSize: number, sorts: DataFetcherSort[], filters: string): Promise<DataFetcherResponse<TData>>
}

export interface PaginatedRequestFunction<T> {
    (page: number, filters?: requestFilterInterface[]): Promise<PaginatedResults<T>>
};

export interface PaginatedResults<T> {
    data: (T & tableItemInterface)[]
    total: number
    perPage: number
    currentPage: number
    lastPage: number
    firstPageUrl: string
    lastPageUrl: string
    nextPageUrl: string
    prevPageUrl: string
    path: string
    from: number
    to: number
};
